import React from 'react';

const Logo = props => {
  return <>PLAYGROUND</>;
};

export default Logo;
